//
// StyleVariables - Mirrored SASS vars
//

// Increment a min breakpoint value by one to get the max
function set_bp_max(min_val) {
  return `${parseInt(min_val, 10) + 1}px`;
}

const bp_min = {
  xs: '480px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1500px',
  xxl: '1800px',
  nav_tray_switch: '1000px',
};

const bp_max = {
  xs: set_bp_max(bp_min.xs),
  sm: set_bp_max(bp_min.sm),
  md: set_bp_max(bp_min.md),
  lg: set_bp_max(bp_min.lg),
  xl: set_bp_max(bp_min.xl),
  xxl: set_bp_max(bp_min.xxl),
  nav_tray_switch: set_bp_max(bp_min.nav_tray_switch),
};

const color_grey = {
  1: '#FCFCFC',
  2: '#F9F9F9',
  3: '#EEEEEE',
  4: '#C6C7CC',
  5: '#868690',
  6: '#51505A',
  7: '#303138',
  8: '#2A282F',
  9: '#27252C',
  10:'#252328',
};

const color_logo = {
  lightblue:   '#7FD6F8',
  green:       '#8AC539',
};

const color_hexicon = {
  blue:   '#57B7DD',
  orange: '#F99132',
  purple: '#A98BBC',
  red:    '#FF6D56',
  green:  '#8AC539',
  yellow: '#FFBE0A',
};

module.exports = {
  bp_min,
  bp_max,
  color_logo,
  color_hexicon,
  color_grey,
};
